const RELOADED_AT_KEY = 'fbl:chunk-reload-at';
const MIN_RELOAD_INTERVAL_MS = 5 * 60 * 1000;

const isChunkLoadError = (reason: unknown): boolean =>
  reason instanceof Error && (reason.name === 'ChunkLoadError' || /Loading chunk [\w-]+ failed/.test(reason.message));

/**
 * A failed chunk load (Clerk's hot-loaded UI, or our own after a deploy) leaves
 * the page half-initialised with no way back except a reload. Reload once, and
 * at most every five minutes so an outage on the chunk host cannot loop. When
 * sessionStorage is unavailable the guard cannot be kept, so no reload happens.
 */
export function installChunkLoadRecovery(): void {
  if (typeof window === 'undefined') return;

  const recover = (reason: unknown) => {
    if (!isChunkLoadError(reason)) return;
    try {
      const last = Number(window.sessionStorage.getItem(RELOADED_AT_KEY) ?? 0);
      if (Date.now() - last < MIN_RELOAD_INTERVAL_MS) return;
      window.sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    } catch {
      return;
    }
    window.location.reload();
  };

  window.addEventListener('unhandledrejection', (event) => recover(event.reason));
  window.addEventListener('error', (event) => recover(event.error));
}
